import * as types from './constants';

export const getUserTasksSortedList = (from, to) => ({
    types: [
        types.GET_USER_TASKS_SORTED_LIST_REQUEST,
        types.GET_USER_TASKS_SORTED_LIST_SUCCESS,
        types.GET_USER_TASKS_SORTED_LIST_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user-tasks/get/?start=${from}&end=${to}`,
            method: 'GET',
        }),
});

export const getUserSchedule = () => ({
    types: [
        types.GET_SCHEDULE_REQUEST,
        types.GET_SCHEDULE_SUCCESS,
        types.GET_SCHEDULE_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/schedules/get`,
            method: 'GET',
        }),
});

export const addUserTask = (data) => ({
    types: [
        types.ADD_USER_TASK_REQUEST,
        types.ADD_USER_TASK_SUCCESS,
        types.ADD_USER_TASK_FAILURE,
    ],
    promise: api =>
        api({
            url: '/api/v1/user-tasks/add',
            method: 'POST',
            body: data,
        })
});

export const updateUserTask = (taskId, data) => ({
    types: [
        types.UPDATE_USER_TASK_REQUEST,
        types.UPDATE_USER_TASK_SUCCESS,
        types.UPDATE_USER_TASK_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user-tasks/update/${taskId}`,
            method: 'POST',
            body: data,
        })
});

export const deleteUserTask = (taskId) => ({
    types: [
        types.DELETE_USER_TASK_REQUEST,
        types.DELETE_USER_TASK_SUCCESS,
        types.DELETE_USER_TASK_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user-tasks/delete/${taskId}`,
            method: 'POST',
        })
});

export const getOrderTasksList = (orderId) => ({
    types: [
        types.GET_ORDER_TASKS_REQUEST,
        types.GET_ORDER_TASKS_SUCCESS,
        types.GET_ORDER_TASKS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user-tasks/get/${orderId}`,
            method: 'GET',
        }),
});

export const changeUserTaskStatus = (taskId, data) => ({
    types: [
        types.CHANGE_STATUS_REQUEST,
        types.CHANGE_STATUS_SUCCESS,
        types.CHANGE_STATUS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user-tasks/status/${taskId}`,
            method: 'POST',
            body: data
        })
});
